import { reportErrorToServer } from '@applyonline/shared'
import { getEnvRuntimeVariable } from '@if/core/utils'

export class RecaptchaUnavailableError extends Error {
  constructor() {
    super('ReCAPTCHA non disponible.')
    this.name = 'RecaptchaUnavailableError'
  }
}

export const getRecaptchaToken = async (
  executeRecaptcha: ((action?: string) => Promise<string>) | undefined,
  action?: string,
): Promise<string> => {
  if (getEnvRuntimeVariable<boolean>(import.meta.env.VITE_RECAPTCHA_ENABLED)) {
    if (!executeRecaptcha) {
      const err = new RecaptchaUnavailableError()
      reportErrorToServer(err)
      throw err
    }

    const recaptchaToken = await executeRecaptcha(action)

    return recaptchaToken
  }

  return ''
}

export default { getRecaptchaToken }
